import CV from "../assets/CV/Ashan_Silva_CV.pdf";
const Header: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-black/40 backdrop-blur-lg border-b border-white/10">
      <div className="max-w-5xl mx-auto p-6 flex items-center justify-between">
        <div className="text-lg font-semibold uppercase">Ashan Silva</div>
        <nav className="space-x-4 text-sm hidden md:flex">
          <a href="#about" className="hover:underline">
            About
          </a>
          <a href="#skills" className="hover:underline">
            Skills
          </a>
          <a href="#experience" className="hover:underline">
            Experience
          </a>
          <a href="#education" className="hover:underline">
            Education
          </a>
          <a href="#projects" className="hover:underline">
            Projects
          </a>
          <a href="#certifications" className="hover:underline">
            Certifications
          </a>
          <a href="#contact" className="hover:underline">
            Contact
          </a>
        </nav>
        <a
          href={CV}
          download="Ashan_Silva_CV.pdf"
          className="ml-4 inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm shadow-sm hover:bg-white/10 transition"
        >
          Download CV
        </a>
      </div>
    </header>
  );
};
export default Header;
